import { Utensils, ShoppingBag, Bike } from 'lucide-react';
import { SERVICES } from '../constants/restaurant';

const ICONS = {
  'dine-in': Utensils,
  takeaway: ShoppingBag,
  delivery: Bike,
};

export const Services = () => {
  return (
    <section
      data-testid="services-section"
      className="relative bg-brand-cream py-20 md:py-28 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-burgundy mb-5">
            How to Enjoy Sankalp
          </p>
          <h2
            data-testid="services-heading"
            className="font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-brand-coffee tracking-tight"
          >
            Three ways to savour every dosa.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((service) => {
            const Icon = ICONS[service.id];
            return (
              <article
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="group relative overflow-hidden rounded-3xl border border-brand-ivory bg-white p-8 md:p-10 hover:-translate-y-2 hover:shadow-[0_30px_60px_rgba(139,26,26,0.12)] transition-all duration-500"
              >
                <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-brand-gold/10 group-hover:bg-brand-gold/20 transition-all duration-700" />
                <div className="relative">
                  <span className="inline-flex w-14 h-14 rounded-2xl bg-brand-burgundy text-brand-cream items-center justify-center shadow-[0_15px_30px_rgba(139,26,26,0.25)]">
                    <Icon className="w-6 h-6" />
                  </span>
                  <h3 className="mt-6 font-serif text-3xl md:text-[34px] text-brand-coffee leading-tight">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-brand-mocha leading-relaxed text-base">
                    {service.description}
                  </p>
                  <span className="mt-6 inline-block text-[11px] uppercase tracking-[0.3em] font-bold text-brand-burgundy">
                    Available 7 Days
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
